import { Component, Inject, OnInit } from '@angular/core';
import { DOperacionesMatematicasServicio } from '@dian-cmp/formulario';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-extemporaneidad',
  templateUrl: './extemporaneidad.component.html',
  styleUrls: ['./extemporaneidad.component.css']
})
export class ExtemporaneidadComponent implements OnInit {

  gradualidad: string = '';
  patrimonioLiquido: string = '';
  boolradbutton=false;
  submitted = false;
  constructor( protected dutilidades: DOperacionesMatematicasServicio,
    public dialogRef: MatDialogRef<ExtemporaneidadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    }

  ngOnInit() {
    if (this.data.patrimonioLiquido && this.data.patrimonioLiquido != "0") {
      this.patrimonioLiquido = this.dutilidades.redondearValorMoneda(this.data.patrimonioLiquido);
      this.patrimonioLiquido = this.dutilidades.obtenerFormatoMoneda(this.data.patrimonioLiquido);
    }
    if (this.data.gradualidad && this.data.gradualidad != "0") {
      this.gradualidad = this.data.gradualidad;
      this.boolradbutton=true;
    }
  }
  redondearValor(valor:string)
{
  this.patrimonioLiquido=this.dutilidades.redondearValorMoneda(valor);
  this.patrimonioLiquido=this.dutilidades.obtenerFormatoMoneda(this.patrimonioLiquido);
 
}  
validateAnswer(value: string) {
    this.boolradbutton=true;
    console.log(value);
  }
  enviar() {
    this.submitted = true;
    
      let respuesta = {
        patrimonioLiquido: this.patrimonioLiquido,
        gradualidad: this.gradualidad
      }
      this.submit(respuesta);
    }
    submit(res: any = '') {
      this.
      dialogRef.close(res);
    }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/extemporaneidad/extemporaneidad.component.ts